import { Form, type InputProps as AntdInputProps } from 'antd';
import { isEmpty } from 'lodash/fp';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useThemeComponents } from '../..';
import breakpoints from '../../../utilities/breakpoints';
import { onPreventDefaultKeyEnter } from '../../../utilities/form';
import { type PromoCodeFieldProps } from '../../context';
import SingleField from '../Input';

const PromoCodeContainer = styled.div`
    margin-top: 10px;
    display: flex;
    align-items: center;
`;

const PromoCodeForm = styled(Form.Item)`
    margin-bottom: 0;
    padding: 0;

    flex: 1;

    .ant-form-item-label {
        padding: 0;
    }
`;

const PromoCodeButton = styled.div`
    margin-top: 24px;
    margin-left: 12px;

    & > .ant-btn {
        display: flex;
        justify-content: center;
        min-width: unset;
        width: 100%;
        padding: 11px 15px;
    }

    @media screen and (max-width: ${breakpoints.md}) {
        /* Prevent clip on mobile view */
        width: auto;
    }
`;

const PromoCodeField = (props: PromoCodeFieldProps) => {
    const {
        onChange: onChangeInput,
        removePromoCode,
        value: promoCodeInput,
        onApply: getValidPromoCode,
        promoCode,
        promoCodeError,
    } = props;

    const { t } = useTranslation('calculators');

    const { Button } = useThemeComponents();
    const inputStatus = useMemo(() => {
        if (!isEmpty(promoCode)) {
            return 'success';
        }
        if (isEmpty(promoCode) && promoCodeError) {
            return 'error';
        }

        return 'none';
    }, [promoCode, promoCodeError]);

    return (
        <PromoCodeContainer>
            <PromoCodeForm label="Promo Code">
                <SingleField
                    onChange={onChangeInput}
                    onFocus={removePromoCode}
                    onPressEnter={onPreventDefaultKeyEnter}
                    status={inputStatus as AntdInputProps['status'] & 'success'}
                    style={{ paddingLeft: '10px' }}
                    value={promoCodeInput}
                />
            </PromoCodeForm>
            <PromoCodeButton>
                <Button onClick={getValidPromoCode} type="primary" block>
                    {t('calculators:actions.apply')}
                </Button>
            </PromoCodeButton>
        </PromoCodeContainer>
    );
};
export default PromoCodeField;
